<template>
  <div>
    <v-simple-table>
      <thead>
        <tr>
          <th>Image</th>
          <th>Title</th>
          <th>Notes</th>
          <th>Category</th>
        </tr>
      </thead>
      <tbody
        v-infinite-scroll="loadMore"
        :infinite-scroll-disabled="disableListScroll"
      >
        <tr
          v-for="recipe in list"
          :key="recipe.id"
          class="clickable new-tab-link-row"
        >
          <td>
            <cloudinary-image
              :image="recipe.image_info"
              :tile="true"
              aspect-ratio="1.7"
              alt="Food Recipe"
              height="70"
              size="70"
            />

            <router-link
              :to="{
                name: 'form.recipe',
                params: { id: recipe.id },
              }"
              class="row-link"
            />
          </td>
          <td>
            {{ recipe.title }}
            <router-link
              :to="{
                name: 'form.recipe',
                params: { id: recipe.id },
              }"
              class="row-link"
            />
          </td>
          <td width="60%">
            {{ recipe.description }}
            <router-link
              :to="{
                name: 'form.recipe',
                params: { id: recipe.id },
              }"
              class="row-link"
            />
          </td>
          <td>
            {{ recipe.categories | readableEnums(categories) }}
            <router-link
              :to="{
                name: 'form.recipe',
                params: { id: recipe.id },
              }"
              class="row-link"
            />
          </td>
        </tr>
      </tbody>

      <table-skeleton-loader v-if="loading" column="4" row />
    </v-simple-table>

    <no-list v-if="!list.length && !loading" details="No Available Videos" />
  </div>
</template>

<script>
import TableSkeletonLoader from '@/components/elements/loaders/TableSkeleton'
import CloudinaryImage from '@/components/elements/CloudinaryImage'
import NoList from '@/components/elements/NoList'
import infiniteScroll from 'vue-infinite-scroll'

import { mdiDotsVertical } from '@mdi/js'
import { mapState } from 'vuex'

export default {
  name: 'RecipeListTable',

  components: {
    TableSkeletonLoader,
    CloudinaryImage,
    NoList,
  },

  directives: {
    infiniteScroll,
  },

  props: {
    loading: {
      type: Boolean,
      default: false,
    },
    list: {
      type: Array,
      default: () => [],
      required: true,
    },
    meta: {
      type: Object,
      required: true,
    },
  },

  data() {
    return {
      icons: {
        action: mdiDotsVertical,
      },
    }
  },

  computed: {
    ...mapState({
      categories: (state) => state.foodCategory.list,
    }),

    disableListScroll() {
      return this.loading || this.meta.current_page >= this.meta.last_page
    },
  },

  methods: {
    loadMore() {
      this.$emit('loadMore', this.meta.current_page + 1)
    },

    showDetails(recipe) {
      this.$emit('goTo', recipe.id)
    },
  },
}
</script>
